/* ===========================================================================
   DAZZURO — liste d envies
   ---------------------------------------------------------------------------
   Stockage cote client, sans application ni serveur :

     - un cookie, pour que la liste survive a la fermeture du navigateur et
       reste lisible par Liquid si un jour on en a besoin ;
     - localStorage en doublon, parce qu un cookie plafonne a 4 Ko et que
       certains navigateurs les effacent plus vite.

   Quand le client est connecte, la cle porte l empreinte de son e-mail : deux
   comptes sur le meme ordinateur ne melangent pas leurs listes, et retrouver
   son compte fait revenir la sienne. La liste ne SUIT PAS d un appareil a
   l autre — cela demanderait de la stocker chez Shopify, donc une application.
   =========================================================================== */
(function () {
  'use strict';

  var CLE_BASE = 'daz_wishlist';
  var JOURS = 365;

  /** Empreinte courte et stable d une chaine — pas un secret, juste une cle. */
  function empreinte(texte) {
    var h = 0;
    for (var i = 0; i < texte.length; i++) {
      h = ((h << 5) - h) + texte.charCodeAt(i);
      h |= 0;
    }
    return Math.abs(h).toString(36);
  }

  function cle() {
    var mail = (window.DazClient && window.DazClient.email) || '';
    return mail ? CLE_BASE + '_' + empreinte(mail.toLowerCase().trim()) : CLE_BASE;
  }

  // ---------------------------------------------------------------- stockage
  function lireCookie(nom) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + nom + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function ecrireCookie(nom, valeur) {
    var fin = new Date();
    fin.setTime(fin.getTime() + JOURS * 864e5);
    document.cookie = nom + '=' + encodeURIComponent(valeur) +
      ';expires=' + fin.toUTCString() + ';path=/;SameSite=Lax';
  }

  function lire() {
    var k = cle();
    var brut = null;
    try { brut = window.localStorage.getItem(k); } catch (e) {}
    if (!brut) brut = lireCookie(k);
    if (!brut) return [];
    try {
      var l = JSON.parse(brut);
      return Array.isArray(l) ? l.filter(Boolean) : [];
    } catch (e) { return []; }
  }

  function ecrire(liste) {
    var k = cle();
    var brut = JSON.stringify(liste);
    try { window.localStorage.setItem(k, brut); } catch (e) {}
    ecrireCookie(k, brut);
    document.dispatchEvent(new CustomEvent('daz:wishlist', { detail: { liste: liste } }));
  }

  // ------------------------------------------------------------------ actions
  function contient(handle) { return lire().indexOf(handle) !== -1; }

  function basculer(handle) {
    var l = lire();
    var i = l.indexOf(handle);
    if (i === -1) l.push(handle); else l.splice(i, 1);
    ecrire(l);
    return i === -1;
  }

  // ------------------------------------------------------------------ rendu
  function majBouton(bouton) {
    var actif = contient(bouton.getAttribute('data-daz-wishlist'));
    bouton.classList.toggle('is-active', actif);
    bouton.setAttribute('aria-pressed', actif ? 'true' : 'false');
    var t = actif ? bouton.getAttribute('data-titre-actif') : bouton.getAttribute('data-titre');
    if (t) { bouton.setAttribute('aria-label', t); bouton.setAttribute('title', t); }
  }

  function majCompteur() {
    var n = lire().length;
    document.querySelectorAll('[data-daz-wishlist-compteur]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-daz-wishlist-lien]').forEach(function (el) {
      el.classList.toggle('has-items', n > 0);
    });
  }

  function majTout() {
    document.querySelectorAll('[data-daz-wishlist]').forEach(majBouton);
    majCompteur();
  }

  // ------------------------------------------------------------------ liaison
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-daz-wishlist]');
    if (!b) return;
    e.preventDefault();
    basculer(b.getAttribute('data-daz-wishlist'));
    majTout();
  });

  document.addEventListener('daz:wishlist', majCompteur);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', majTout);
  } else {
    majTout();
  }

  /* expose le minimum : une page dediee pourra lire la liste */
  window.DazWishlist = { lire: lire, contient: contient, basculer: basculer };
})();
